import { useCallback, useEffect, useState } from 'react';

import { PromotionPiece } from '@libs/chess/types';
import { getLocalStorage } from '@libs/storage';
import { Subscription } from '@libs/subscription';

const LOCAL_STORAGE_KEY = 'autopromotion';
const LOCAL_STORAGE = getLocalStorage();

const globalSubscription = new Subscription<PromotionPiece | undefined>();

export function useAutoPromotion() {
  const [autoPromotion, setAutoPromotion] = useState(() => {
    return LOCAL_STORAGE.getItem(LOCAL_STORAGE_KEY) as PromotionPiece | undefined;
  });

  // синхронизация инстансов
  useEffect(() => {
    return globalSubscription.subscribe((p) => {
      setAutoPromotion(p);
    });
  }, []);

  return {
    autoPromotion,
    setAutoPromotion: useCallback((p: PromotionPiece | null) => {
      const val = p ?? undefined;
      setAutoPromotion(val);
      globalSubscription.publish(val);

      if (p) {
        LOCAL_STORAGE.setItem(LOCAL_STORAGE_KEY, p);
      } else {
        LOCAL_STORAGE.removeItem(LOCAL_STORAGE_KEY);
      }
    }, []),
  };
}
